import React from 'react';

import {Helmet} from 'views/module';

import SkillsScene from 'views/scenes/skills/Skills';

const SkillsPage = (props) => {
  return (
    <>
      <Helmet>
        <title>Quilt: Skills</title>
      </Helmet>
      <SkillsScene />
    </>
  );
};

export default SkillsPage;
